module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    var child0 = (function() {
      var child0 = (function() {
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, content = hooks.content;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            content(env, morph0, context, "language.name");
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, get = hooks.get, block = hooks.block;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          block(env, morph0, context, "sm-select-option", [], {"option": get(env, context, "language")}, child0, null);
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createComment("");
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
        dom.insertBoundary(fragment, null);
        dom.insertBoundary(fragment, 0);
        block(env, morph0, context, "each", [get(env, context, "languages")], {"keyword": "language"}, child0, null);
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.low_perfomance.enable"], {});
        return fragment;
      }
    };
  }());
  var child2 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.low_perfomance.disable"], {});
        return fragment;
      }
    };
  }());
  var child3 = (function() {
    var child0 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","caption");
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
          inline(env, morph0, context, "t", ["settings.interface.feature.hide_map.enable"], {});
          return fragment;
        }
      };
    }());
    var child1 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","caption");
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
          inline(env, morph0, context, "t", ["settings.interface.feature.hide_map.disable"], {});
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","form-group-horizontal");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","control-label");
        dom.appendChild(el1, el2);
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","form-control");
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","toggle-group");
        var el4 = dom.createComment("");
        dom.appendChild(el3, el4);
        var el4 = dom.createElement("div");
        dom.setAttribute(el4,"class","caption");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, inline = hooks.inline, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element3 = dom.childAt(fragment, [0, 1]);
        var element4 = dom.childAt(element3, [0]);
        var morph0 = dom.createMorphAt(element4,0,0);
        var morph1 = dom.createMorphAt(dom.childAt(element4, [1]),0,0);
        var morph2 = dom.createMorphAt(element3,1,1);
        inline(env, morph0, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "hideMapInOrders"), "onchange": "hideMapInOrdersChanged"});
        inline(env, morph1, context, "t", ["settings.interface.feature.hide_map.description"], {});
        block(env, morph2, context, "if", [get(env, context, "hideMapInOrders")], {}, child0, child1);
        return fragment;
      }
    };
  }());
  var child4 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.map_mouse_wheel.enable"], {});
        return fragment;
      }
    };
  }());
  var child5 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.map_mouse_wheel.disable"], {});
        return fragment;
      }
    };
  }());
  var child6 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.hide_pickup_orders_at_now.enable"], {});
        return fragment;
      }
    };
  }());
  var child7 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.hide_pickup_orders_at_now.disable"], {});
        return fragment;
      }
    };
  }());
  var child8 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.hide_later_orders_on_map.enable"], {});
        return fragment;
      }
    };
  }());
  var child9 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.hide_unauthorized_couriers.enable"], {});
        return fragment;
      }
    };
  }());
  var child10 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.hide_order_notifications.enable"], {});
        return fragment;
      }
    };
  }());
  var child11 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.hide_order_notifications.disable"], {});
        return fragment;
      }
    };
  }());
  var child12 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.sound_notifications.enable"], {});
        return fragment;
      }
    };
  }());
  var child13 = (function() {
    var child0 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createElement("div");
          dom.setAttribute(el1,"class","caption");
          var el2 = dom.createComment("");
          dom.appendChild(el1, el2);
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
          inline(env, morph0, context, "t", ["settings.interface.feature.sound_notifications_repeat.enable"], {});
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","plain-form-section");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","form-group-horizontal");
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","control-label");
        dom.appendChild(el2, el3);
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","form-control");
        var el4 = dom.createElement("div");
        dom.setAttribute(el4,"class","toggle-group");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        var el5 = dom.createElement("div");
        dom.setAttribute(el5,"class","caption");
        var el6 = dom.createComment("");
        dom.appendChild(el5, el6);
        dom.appendChild(el4, el5);
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, inline = hooks.inline, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element2 = dom.childAt(fragment, [0, 0, 1, 0]);
        var morph0 = dom.createMorphAt(element2,0,0);
        var morph1 = dom.createMorphAt(dom.childAt(element2, [1]),0,0);
        var morph2 = dom.createMorphAt(element2,2,2);
        inline(env, morph0, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "soundNotificationsRepeat"), "onchange": "soundNotificationsRepeat"});
        inline(env, morph1, context, "t", ["settings.interface.feature.sound_notifications_repeat.description"], {});
        block(env, morph2, context, "if", [get(env, context, "soundNotificationsRepeat")], {}, child0, null);
        return fragment;
      }
    };
  }());
  var child14 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","plain-form-section");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","form-group-horizontal");
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","control-label");
        var el4 = dom.createComment("");
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        var el3 = dom.createElement("div");
        dom.setAttribute(el3,"class","form-control");
        var el4 = dom.createComment("");
        dom.appendChild(el3, el4);
        var el4 = dom.createElement("div");
        dom.setAttribute(el4,"class","caption");
        var el5 = dom.createComment("");
        dom.appendChild(el4, el5);
        var el5 = dom.createTextNode("        ");
        dom.appendChild(el4, el5);
        dom.appendChild(el3, el4);
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline, get = hooks.get;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element0 = dom.childAt(fragment, [0, 0]);
        var element1 = dom.childAt(element0, [1]);
        var morph0 = dom.createMorphAt(dom.childAt(element0, [0]),0,0);
        var morph1 = dom.createMorphAt(element1,0,0);
        var morph2 = dom.createMorphAt(dom.childAt(element1, [1]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.repeat_interval.description"], {});
        inline(env, morph1, context, "input", [], {"type": "range", "value": get(env, context, "notificationsRepeatSoundInterval"), "min": "1", "max": "60", "onchange": "NotificationsRepeatSoundInterval"});
        inline(env, morph2, context, "t", ["settings.interface.feature.repeat_interval.enable"], {"interval": get(env, context, "notificationsRepeatSoundInterval")});
        return fragment;
      }
    };
  }());
  var child15 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createElement("br");
        dom.appendChild(el1, el2);
        var el2 = dom.createTextNode("🎉🥁🥳🎊! ");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        return fragment;
      }
    };
  }());
  var child16 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.integrations_settings.enable"], {});
        return fragment;
      }
    };
  }());
  var child17 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.show_button_for_optional_modifiers.enable"], {});
        return fragment;
      }
    };
  }());
  var child18 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","caption");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        inline(env, morph0, context, "t", ["settings.interface.feature.show_dish_photo_in_order_card.enable"], {});
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","plain-form profile-form");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-header");
      var el3 = dom.createElement("h1");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("h2");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","caption");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","plain-form-section");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","form-group-horizontal");
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","control-label");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","form-control");
      var el5 = dom.createElement("div");
      dom.setAttribute(el5,"class","toggle-group");
      var el6 = dom.createComment("");
      dom.appendChild(el5, el6);
      var el6 = dom.createElement("div");
      dom.setAttribute(el6,"class","caption");
      var el7 = dom.createComment("");
      dom.appendChild(el6, el7);
      dom.appendChild(el5, el6);
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, inline = hooks.inline, get = hooks.get, block = hooks.block;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element5 = dom.childAt(fragment, [0]);
      var element6 = dom.childAt(element5, [0]);
      var element7 = dom.childAt(element5, [1, 0]);
      var element8 = dom.childAt(element7, [1]);
      var element9 = dom.childAt(element5, [2]);
      var element10 = dom.childAt(element9, [0, 1]);
      var element11 = dom.childAt(element10, [0]);
      var element12 = dom.childAt(element9, [2, 1]);
      var element13 = dom.childAt(element12, [0]);
      var element14 = dom.childAt(element5, [3]);
      var element15 = dom.childAt(element14, [0, 1]);
      var element16 = dom.childAt(element15, [0]);
      var element17 = dom.childAt(element14, [1, 1]);
      var element18 = dom.childAt(element17, [0]);
      var element19 = dom.childAt(element14, [2, 1]);
      var element20 = dom.childAt(element19, [0]);
      var element21 = dom.childAt(element5, [4, 0]);
      var element22 = dom.childAt(element21, [1]);
      var element23 = dom.childAt(element5, [5, 0, 1]);
      var element24 = dom.childAt(element23, [0]);
      var element25 = dom.childAt(element5, [6, 0]);
      var element26 = dom.childAt(element25, [1]);
      var element27 = dom.childAt(element5, [7, 0, 1]);
      var element28 = dom.childAt(element27, [0]);
      var element29 = dom.childAt(element5, [10, 0, 1]);
      var element30 = dom.childAt(element29, [0]);
      var element31 = dom.childAt(element5, [11, 0, 1]);
      var element32 = dom.childAt(element31, [0]);
      var element33 = dom.childAt(element5, [12]);
      var element34 = dom.childAt(element33, [0, 1]);
      var element35 = dom.childAt(element34, [0]);
      var element36 = dom.childAt(element33, [1, 1]);
      var element37 = dom.childAt(element36, [0]);
      var morph0 = dom.createMorphAt(dom.childAt(element6, [0]),0,0);
      var morph1 = dom.createMorphAt(dom.childAt(element6, [1]),0,0);
      var morph2 = dom.createMorphAt(dom.childAt(element7, [0]),0,0);
      var morph3 = dom.createMorphAt(dom.childAt(element8, [0]),0,0);
      var morph4 = dom.createMorphAt(dom.childAt(element8, [1]),0,0);
      var morph5 = dom.createMorphAt(element11,0,0);
      var morph6 = dom.createMorphAt(dom.childAt(element11, [1]),0,0);
      var morph7 = dom.createMorphAt(element10,1,1);
      var morph8 = dom.createMorphAt(element9,1,1);
      var morph9 = dom.createMorphAt(element13,0,0);
      var morph10 = dom.createMorphAt(dom.childAt(element13, [1]),0,0);
      var morph11 = dom.createMorphAt(element12,1,1);
      var morph12 = dom.createMorphAt(element16,0,0);
      var morph13 = dom.createMorphAt(dom.childAt(element16, [1]),0,0);
      var morph14 = dom.createMorphAt(element15,1,1);
      var morph15 = dom.createMorphAt(element18,0,0);
      var morph16 = dom.createMorphAt(dom.childAt(element18, [1]),0,0);
      var morph17 = dom.createMorphAt(element17,1,1);
      var morph18 = dom.createMorphAt(element20,0,0);
      var morph19 = dom.createMorphAt(dom.childAt(element20, [1]),0,0);
      var morph20 = dom.createMorphAt(element19,1,1);
      var morph21 = dom.createMorphAt(dom.childAt(element21, [0]),0,0);
      var morph22 = dom.createMorphAt(element22,0,0);
      var morph23 = dom.createMorphAt(dom.childAt(element22, [1]),0,0);
      var morph24 = dom.createMorphAt(element24,0,0);
      var morph25 = dom.createMorphAt(dom.childAt(element24, [1]),0,0);
      var morph26 = dom.createMorphAt(element23,1,1);
      var morph27 = dom.createMorphAt(dom.childAt(element25, [0]),0,0);
      var morph28 = dom.createMorphAt(element26,0,0);
      var morph29 = dom.createMorphAt(dom.childAt(element26, [1]),0,0);
      var morph30 = dom.createMorphAt(element28,0,0);
      var morph31 = dom.createMorphAt(dom.childAt(element28, [1]),0,0);
      var morph32 = dom.createMorphAt(element27,1,1);
      var morph33 = dom.createMorphAt(element5,8,8);
      var morph34 = dom.createMorphAt(element5,9,9);
      var morph35 = dom.createMorphAt(element30,0,0);
      var morph36 = dom.createMorphAt(dom.childAt(element30, [1]),0,0);
      var morph37 = dom.createMorphAt(element29,1,1);
      var morph38 = dom.createMorphAt(element32,0,0);
      var morph39 = dom.createMorphAt(dom.childAt(element32, [1]),0,0);
      var morph40 = dom.createMorphAt(element31,1,1);
      var morph41 = dom.createMorphAt(element35,0,0);
      var morph42 = dom.createMorphAt(dom.childAt(element35, [1]),0,0);
      var morph43 = dom.createMorphAt(element34,1,1);
      var morph44 = dom.createMorphAt(element37,0,0);
      var morph45 = dom.createMorphAt(dom.childAt(element37, [1]),0,0);
      var morph46 = dom.createMorphAt(element36,1,1);
      inline(env, morph0, context, "t", ["settings.interface.title"], {});
      inline(env, morph1, context, "t", ["settings.interface.subtitle"], {});
      inline(env, morph2, context, "t", ["settings.interface.feature.language.label"], {});
      block(env, morph3, context, "sm-select", [], {"labelPath": ".name", "selectedOption": get(env, context, "currentLanguage")}, child0, null);
      inline(env, morph4, context, "t", ["settings.interface.feature.language.caption"], {});
      inline(env, morph5, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "lowPerformanceMode"), "onchange": "lowPerformanceModeChanged"});
      inline(env, morph6, context, "t", ["settings.interface.feature.low_perfomance.description"], {});
      block(env, morph7, context, "if", [get(env, context, "lowPerformanceMode")], {}, child1, child2);
      block(env, morph8, context, "if", [get(env, context, "lowPerformanceMode")], {}, child3, null);
      inline(env, morph9, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "mapScrollOnMouseWheel"), "onchange": "mapScrollOnMouseWheelChanged"});
      inline(env, morph10, context, "t", ["settings.interface.feature.map_mouse_wheel.description"], {});
      block(env, morph11, context, "if", [get(env, context, "mapScrollOnMouseWheel")], {}, child4, child5);
      inline(env, morph12, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "hidePickupOrdersAtNow"), "onchange": "HidePickupOrdersAtNowChanged"});
      inline(env, morph13, context, "t", ["settings.interface.feature.hide_pickup_orders_at_now.description"], {});
      block(env, morph14, context, "if", [get(env, context, "hidePickupOrdersAtNow")], {}, child6, child7);
      inline(env, morph15, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "hideLaterOrdersOnMap"), "onchange": "hideLaterOrdersOnMapChanged"});
      inline(env, morph16, context, "t", ["settings.interface.feature.hide_later_orders_on_map.description"], {});
      block(env, morph17, context, "if", [get(env, context, "hideLaterOrdersOnMap")], {}, child8, null);
      inline(env, morph18, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "hideUnauthorizedCouriers"), "onchange": "hideUnauthorizedCouriersChanged"});
      inline(env, morph19, context, "t", ["settings.interface.feature.hide_unauthorized_couriers.description"], {});
      block(env, morph20, context, "if", [get(env, context, "hideUnauthorizedCouriers")], {}, child9, null);
      inline(env, morph21, context, "t", ["settings.interface.feature.check_interval.description"], {});
      inline(env, morph22, context, "input", [], {"type": "range", "value": get(env, context, "monitorCheckInterval"), "min": "1", "max": "60", "onchange": "MonitorCheckIntervalChanged"});
      inline(env, morph23, context, "t", ["settings.interface.feature.check_interval.enable"], {"interval": get(env, context, "monitorCheckInterval")});
      inline(env, morph24, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "hideOrderNotifications"), "onchange": "HideOrderNotificationsChanged"});
      inline(env, morph25, context, "t", ["settings.interface.feature.hide_order_notifications.description"], {});
      block(env, morph26, context, "if", [get(env, context, "hideOrderNotifications")], {}, child10, child11);
      inline(env, morph27, context, "t", ["settings.interface.feature.notification_duration.description"], {});
      inline(env, morph28, context, "input", [], {"type": "range", "value": get(env, context, "notificationDuration"), "min": "1", "max": "60", "onchange": "notificationDurationChanged"});
      inline(env, morph29, context, "t", ["settings.interface.feature.notification_duration.enable"], {"interval": get(env, context, "notificationDuration")});
      inline(env, morph30, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "soundNotifications"), "onchange": "soundNotificationsChanged"});
      inline(env, morph31, context, "t", ["settings.interface.feature.sound_notifications.description"], {});
      block(env, morph32, context, "if", [get(env, context, "soundNotifications")], {}, child12, null);
      block(env, morph33, context, "if", [get(env, context, "soundNotifications")], {}, child13, null);
      block(env, morph34, context, "if", [get(env, context, "soundNotificationsRepeat")], {}, child14, null);
      inline(env, morph35, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "soundNotificationsVerbose"), "onchange": "soundNotificationsVerboseChanged"});
      inline(env, morph36, context, "t", ["settings.interface.feature.sound_notifications_verbose.description"], {});
      block(env, morph37, context, "if", [get(env, context, "soundNotificationsVerbose")], {}, child15, null);
      inline(env, morph38, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "integrationsSettings"), "onchange": "integrationsSettingsChanged"});
      inline(env, morph39, context, "t", ["settings.interface.feature.integrations_settings.description"], {});
      block(env, morph40, context, "if", [get(env, context, "integrationsSettings")], {}, child16, null);
      inline(env, morph41, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "showButtonForOptionalModifiers"), "onchange": "showButtonForOptionalModifiersChanged"});
      inline(env, morph42, context, "t", ["settings.interface.feature.show_button_for_optional_modifiers.description"], {});
      block(env, morph43, context, "if", [get(env, context, "showButtonForOptionalModifiers")], {}, child17, null);
      inline(env, morph44, context, "sm-toggle", [], {"classNames": "left", "checked": get(env, context, "showDishPhotoInOrderCard"), "onchange": "showDishPhotoInOrderCardChanged"});
      inline(env, morph45, context, "t", ["settings.interface.feature.show_dish_photo_in_order_card.description"], {});
      block(env, morph46, context, "if", [get(env, context, "showDishPhotoInOrderCard")], {}, child18, null);
      return fragment;
    }
  };
}()));